import type { TimeRangePickerProps } from 'antd';
import dayjs from 'dayjs';

export const filterRangePresets: TimeRangePickerProps['presets'] = [
  { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
  { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Last 2 Days', value: [dayjs().add(-2, 'd'), dayjs().add(-1, 'd')] },
  { label: 'Today', value: [dayjs(), dayjs()] },
  { label: 'Next 2 Days', value: [dayjs().add(1, 'd'), dayjs().add(2, 'd')] },
  { label: 'Next 7 Days', value: [dayjs(), dayjs().add(7, 'd')] },
  { label: 'Next 14 Days', value: [dayjs(), dayjs().add(14, 'd')] },
];
